import { authConfig } from "../apiConfig";

// for get all completed future schedule reports
export const get_future_schedule_reports_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getFutureScheduleReport`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};